import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import TradesIcon from '@interxfi/design-system/icons/react/icon-trades';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { IncreaseWireConfirmSyncAllDialog } from '../../../../../../../../../../features/vendor/increase/wire/increase-wire-confirm-sync-all-dialog';
import { IncreaseWiresTable } from '../../../../../../../../../../features/vendor/increase/wire/increase-wires-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorIncrease,
      label: 'Wires',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorIncrease>,
  head: () => getPageHead('Increase Wires'),
  component: IncreaseWireList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <IncreaseWireConfirmSyncAllDialog
              trigger={
                <Button affixIcon={<TradesIcon aria-hidden />} aria-label="Sync All Increase Wire Transfers" size="small">
                  Sync All
                </Button>
              }
            />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorIncrease}
    />
  );
}

function IncreaseWireList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <IncreaseWiresTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
